import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { XCircleIcon24Regular } from "../../../../../icons2022/XCircleIcon/XCircleIcon24Regular";
import { XCircleIcon32Regular } from "../../../../../icons2022/XCircleIcon/XCircleIcon32Regular";
import { XCircleIcon64Regular } from "../../../../../icons2022/XCircleIcon/XCircleIcon64Regular";
export var ValidationErrorIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(XCircleIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(XCircleIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(XCircleIcon64Regular, null);
  }
}, 'ValidationErrorIcon');